import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import BarreNav from '../components/BarreNav';
import { CHOIX, lireTheme, definirTheme } from '../services/theme';
import { surSuivi } from '../services/position';

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(lireTheme);
  const [suivi, setSuivi] = useState(null);

  useEffect(() => surSuivi(setSuivi), []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initiales = `${user?.prenom?.[0] || ''}${user?.nom?.[0] || ''}`.toUpperCase();

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="back-btn" onClick={() => navigate('/planning')}>‹</div>
        <div className="topbar-title">Mon compte</div>
      </div>

      <div className="content">
        {/* Avatar + nom */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 0 24px' }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: 'linear-gradient(135deg, #185FA5, #D42B2B)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32, fontWeight: 800, color: '#fff', marginBottom: 14,
          }}>
            {initiales}
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--texte)' }}>
            {user?.prenom} {user?.nom}
          </div>
          <div style={{ fontSize: 13, color: 'var(--texte-doux)', marginTop: 4 }}>
            {user?.secteur || 'Technicien FTTH'}
          </div>
        </div>

        {/* Infos compte */}
        <div className="section-card">
          <div className="section-label">Informations du compte</div>
          {[
            ['Prénom', user?.prenom],
            ['Nom', user?.nom],
            ['Login', user?.login],
            ['Secteur', user?.secteur || '—'],
            ['Identifiant Zoho', user?.zoho_nom || '—'],
          ].map(([label, value]) => (
            <div key={label} className="info-row">
              <span className="info-key">{label}</span>
              <span className="info-val">{value}</span>
            </div>
          ))}
        </div>

        {/* Réglages */}
        <div className="section-card">
          <div className="section-label">Réglages</div>
          <div style={{ fontSize: 14, color: 'var(--texte)', marginBottom: 4 }}>Apparence</div>
          <div style={{ fontSize: 12, color: 'var(--texte-doux)', marginBottom: 10 }}>
            « Système » suit le réglage de votre téléphone et bascule seul le soir.
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            {CHOIX.map(c => {
              const actif = c.valeur === theme;
              return (
                <button
                  key={c.valeur}
                  onClick={() => { definirTheme(c.valeur); setTheme(c.valeur); }}
                  aria-pressed={actif}
                  style={{
                    flex: 1, padding: '9px 6px', fontSize: 13, fontWeight: 600, borderRadius: 10,
                    border: `1px solid ${actif ? 'var(--accent)' : 'var(--bord-fort)'}`,
                    background: actif ? 'var(--accent-plein)' : 'var(--surface)',
                    color: actif ? '#fff' : 'var(--accent)', cursor: 'pointer',
                  }}
                >{c.libelle}</button>
              );
            })}
          </div>
        </div>

        {/* Position — ce qui est relevé, et par qui.

            Un relevé qu'on ne voit pas est un relevé qu'on subit. Le bloc dit
            trois choses : que la position part, quand elle est partie la
            dernière fois, et chez quel client le serveur l'a reconnu. Rien
            n'est modifiable ici : couper la géolocalisation se fait dans les
            réglages du téléphone, et l'agence le verra. */}
        <div className="section-card">
          <div className="section-label">Position</div>
          {suivi && suivi.erreur === 'refus' ? (
            <>
              <div style={{ fontSize: 14, color: 'var(--danger)', marginBottom: 6 }}>
                Géolocalisation refusée
              </div>
              <div style={{ fontSize: 12, color: 'var(--texte-doux)', lineHeight: 1.5 }}>
                L'agence ne voit pas où vous êtes et doit vous appeler pour le
                savoir. Pour la réactiver : réglages du téléphone, puis
                autorisations du navigateur.
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 14, color: 'var(--texte)', marginBottom: 6 }}>
                {suivi && suivi.actif ? 'Relevée pendant que l’application est ouverte' : 'En attente du premier relevé'}
              </div>
              <div style={{ fontSize: 12, color: 'var(--texte-doux)', lineHeight: 1.5 }}>
                Votre position part toutes les deux minutes, uniquement quand
                l’application est au premier plan. Elle sert à reconnaître vos
                arrivées sans que vous ayez à les pointer. Rien n’est relevé
                quand l’application est fermée.
              </div>
              {suivi && suivi.dernier && (
                <div className="info-row" style={{ marginTop: 10 }}>
                  <span className="info-key">Dernier relevé</span>
                  <span className="info-val">
                    {new Date(suivi.dernier).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              )}
              {suivi && suivi.ici && (
                <div className="info-row">
                  <span className="info-key">Reconnu sur</span>
                  <span className="info-val">{suivi.ici.ref}</span>
                </div>
              )}
              {suivi && suivi.erreur === 'indisponible' && (
                <div style={{ fontSize: 12, color: 'var(--texte-doux)', marginTop: 8 }}>
                  Le téléphone ne trouve pas sa position en ce moment — sous-sol,
                  parking. Cela se rétablit tout seul.
                </div>
              )}
            </>
          )}
        </div>

        {/* Déconnexion */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%', padding: '14px', marginTop: 24,
            background: 'var(--surface)', color: 'var(--danger)',
            border: '1.5px solid var(--danger)', borderRadius: 14,
            fontSize: 15, fontWeight: 700, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}
        >
          <span>↩</span> Se déconnecter
        </button>

        <div style={{ height: 16 }} />
      </div>

      <BarreNav actif="profil" />
    </div>
  );
}
